import * as React from 'react';
import { isEmpty } from 'lodash';

import MentionCardDetails from 'components/mention-card/mention-card-details/MentionCardDetails';
import MentionCardLocation from 'components/mention-card/mention-card-location/MentionCardLocation';
import MentionCardDate from 'components/mention-card/mention-card-date/MentionCardDate';

import { getEngagementRateValue } from 'components/mention-card/utils/mention-card';
import { abbrNum } from 'utils/helper/common';

import type { MentionCardMetrics, MentionCardMetricsDetails } from 'types';

import './mention-card-details-instagram.scss';

class MentionCardDetailsInstagram extends MentionCardDetails {
  getMetrics(): MentionCardMetrics {
    const { post } = this.props;
    const { likes, comments, engagementRate } = post;
    const values = { likes, comments, engagementRate };

    const details: MentionCardMetricsDetails = {
      likes: {
        icon: 'heart-custom-fg',
        modifier: abbrNum
      },
      comments: {
        icon: 'speech-bubble-custom-fg',
        modifier: abbrNum
      },
      engagementRate: {
        icon: 'rotation-arrows-custom-fg',
        modifier: getEngagementRateValue,
        mark: '%'
      }
    };

    return {
      values,
      details
    };
  }

  renderLayout(): React.ReactNode {
    const { post, children } = this.props;
    const metrics = this.getMetrics();

    return (
      <div className="mention-card-details-instagram__layout">
        {
          children && (
            <div className="mention-card-details-instagram__children">
              {children}
            </div>
          )
        }
        <div className="mention-card-details-instagram__specifics">
          {
            !isEmpty(post.matchedSearchTermsNames) &&
              this.renderStatusLabels(post.matchedSearchTermsNames)
          }
          {
            this.renderMetrics(metrics, 'instagram')
          }
          {
            !isEmpty(post.location) && (
              <MentionCardLocation
                location={post.location}
              />
            )
          }
          <MentionCardDate date={post.date} />
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div
        className="mention-card-details-instagram"
        data-qa="mention-card-details-instagram"
      >
        {this.renderLayout()}
      </div>
    );
  }
}

export default MentionCardDetailsInstagram;
